import { marketingFooterLegalHref, marketingFooterLegalLinks } from "../lib/marketingSite.js";

type AdminLegalFooterProps = {
  variant?: "default" | "compact";
};

export const AdminLegalFooter = ({ variant = "default" }: AdminLegalFooterProps) => {
  const year = new Date().getFullYear();

  return (
    <footer
      className={
        variant === "compact"
          ? "admin-legal-footer admin-legal-footer--compact"
          : "admin-legal-footer"
      }
      aria-label="Legal and policies"
    >
      <nav className="admin-legal-footer-nav">
        {marketingFooterLegalLinks.map((link) => (
          <a
            key={link.path.length === 0 ? "legal-hub" : link.path}
            href={marketingFooterLegalHref(link.path)}
            target="_blank"
            rel="noreferrer"
            className="admin-legal-footer-link"
          >
            {link.label}
          </a>
        ))}
      </nav>
      <p className="admin-legal-footer-copy">
        &copy; {String(year)} Veritrellis · Documents open on veritrellis.ai
      </p>
    </footer>
  );
};
